export const Endpoint = {
  logIn: '/auth/login',
  getReports:          '/reports/',
  getInterviewQuestion:'/questions/',
  getInterviews:       '/interviews_new/',
  scheduleInterview:   '/interviews_new/',
  interviewUpdate:     '/interviews_new/',
  validateAnswer:      '/validate-answer/',
  analyze:             '/analyze/',
  face_match:          '/face_match/',
  ocr:                 '/ocr',
  liveness:            '/liveness/',
  livenessVideo:       '/liveness_video/',
  detectIdCard:        '/detect_id_card/',
  faceMatch:           '/face_match2/',
  getTechnologies:     '/technology/',
  getUsers:            '/users/',
  users:               '/users/',
  departments:         '/departments/',
  designations:        '/designations/',
  employees:           '/employees/',
  employeeStats:       '/employees/stats/summary',
  onboarding:          '/onboarding/',
  attendance:          '/attendance/',
  attendanceToday:     '/attendance/today',
  attendanceStats:     '/attendance/stats',
  leaveTypes:          '/leave-types/',
  leaveRequests:       '/leave-requests/',
  leaveBalances:       '/leave-requests/balances/',
  holidays:            '/holidays/',
  upcomingHolidays:    '/holidays/upcoming',
  // Payroll
  salaryStructures:    '/salary-structures/',
  salaryComponents:    '/salary-structures/components/',
  salaryAssign:        '/salary-structures/assign',
  salaryAssignments:   '/salary-structures/assignments/all',
  payrollRuns:         '/payroll/runs',
  payrollStats:        '/payroll/stats',
  payslips:            '/payslips/',
  taxDeclarations:     '/tax/',
  taxCompute:          '/tax/compute/',
  taxDeclare:          '/tax/declare',
  leaveTypes: '/leave-types/',
  assets:     '/assets/',
  assetStats: '/assets/stats',

};